
interface FeatureItem {
    icon?: string,
    emo?: string,
    label: React.ReactNode,
    content: React.ReactNode
}

interface HomeFeaturesProps {
    badges?: string[],
    children?: React.ReactNode;
}

interface HomeFeatureItemProps {
    item: FeatureItem,
}

export function HomeFeatureItem({ item }: HomeFeatureItemProps) {
    return (
        <article className="home-features__item">
            <p className="home-features__item-image">
                {item.icon ?
                    <img src={item.icon} alt="" />
                    :
                    <span style={{fontSize: '100px', lineHeight: 'normal'}}>{item.emo}</span>
                }
            </p>
            <h2 className="home-features__item-heading">{item.label}</h2>
            <p className="home-features__item-copy">
                {item.content}
            </p>
        </article>
    )
}

function HomeFeatures({ children }: HomeFeaturesProps) {
    return (
        <section className="home-features">
            {children}
        </section>
    )
}

export default HomeFeatures;